// extracted by mini-css-extract-plugin
module.exports = {"registerContainer":"register_registerContainer__1v7gm","loadingContainer":"register_loadingContainer__1J5v-"};